import styled from 'styled-components';
import { colors } from '../../../../utils/utils';

const COUNT_PILL_TYPE: Record<'whitelist' | 'blacklist', { 'background-color': string }> = {
    whitelist: {
        'background-color': colors.green.aquamarine
    },
    blacklist: {
        'background-color': colors.red.light_carmine_pink // background: `1px solid rgba(255, 80, 110, .5)`
    }
};

const Wrapper = styled.div<{ $type?: 'whitelist' | 'blacklist' | '' }>`
    ${props => (props.$type && props.$type in COUNT_PILL_TYPE ? COUNT_PILL_TYPE[props.$type as 'whitelist' | 'blacklist'] : '')};
    border-radius: 100px;
    padding: 3px 9px;
    font-size: 12px;
    font-weight: 600;
    text-align: center;
    color: ${colors.white.basic};
`;

export default Wrapper;
